import { render, staticRenderFns } from "./secure-update.vue?vue&type=template&id=1496ba4a&scoped=true&"
import script from "./secure-update.vue?vue&type=script&lang=tsx&"
export * from "./secure-update.vue?vue&type=script&lang=tsx&"
import style0 from "./secure-update.vue?vue&type=style&index=0&id=1496ba4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496ba4a",
  null
  
)

export default component.exports